import FollowingService from 'src/modules/following/followingService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'FOLLOWING_VIEW';

const followingViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: followingViewActions.FIND_STARTED,
      });

      const record = await FollowingService.find(id);

      dispatch({
        type: followingViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: followingViewActions.FIND_ERROR,
      });

      getHistory().push('/following');
    }
  },
};

export default followingViewActions;
